import React from "react";
import { useCharacteristicProgress } from "./hooks/useCharacteristicProgress";
import { CharacteristicProgressEditMode } from "./CharacteristicProgressEditMode";
import { CharacteristicProgressViewMode } from "./CharacteristicProgressViewMode";
import ConfirmationModal from "../../../secondary/ConfirmationModal/ConfirmationModal";
import { ReadOnlyBanner } from "../../../secondary/ReadOnlyBanner/ReadOnlyBanner";

const CONFIRMATION_MESSAGE = "All progress in this section will be lost. Are you sure want to cancel?";

export const CharacteristicProgress = ({
  index,
  updateDone,
  selectedIndex,
  styles,
  patientId,
  assessmentId,
  assessmentDetails,
  getCharDetails,
  overrideToggle,
  isCompleted,
  historyCauseCompleted,
  characteristicTabsData,
  isReadOnly,
  hasPermission,
}) => {
  const hook = useCharacteristicProgress({
    index,
    updateDone,
    selectedIndex,
    patientId,
    assessmentId,
    assessmentDetails,
    getCharDetails,
    overrideToggle,
    isCompleted,
  });

  return (
    <>
      {hook.confirmationModal && (
        <ConfirmationModal message={CONFIRMATION_MESSAGE} onClose={hook.confirmationClose} onConfirm={hook.yesConfirmationModalClick} />
      )}

      { isReadOnly && <ReadOnlyBanner /> }

      <div className={`${styles.mesurement_blk} pt-1 pb-0`}>
        <div>
          {hook.editable ? (
            <CharacteristicProgressEditMode
              styles={styles}
              assessmentDetails={assessmentDetails}
              assessmentDetailsNew={hook.assessmentDetailsNew}
              woundProgressOptions={hook.woundProgressOptions}
              isCompleted={isCompleted}
              isProgressResolve={hook.isProgressResolve}
              historyCauseCompleted={historyCauseCompleted}
              characteristicTabsData={characteristicTabsData}
              register={hook.register}
              handleSubmit={hook.handleSubmit}
              doSubmit={hook.doSubmit}
              setFormChangesConfirm={hook.setFormChangesConfirm}
              setClickCancel={hook.setClickCancel}
              woundProgressResolve={hook.woundProgressResolve}
              handleYesProgress={hook.handleYesProgress}
              handleNoProgress={hook.handleNoProgress}
              isSignedLocked={hook.isSignedLocked}
            />
          ) : (
            <CharacteristicProgressViewMode
              styles={styles}
              assessmentDetails={assessmentDetails}
              assessmentDetailsNew={hook.assessmentDetailsNew}
              woundProgressOptions={hook.woundProgressOptions}
              onEdit={() => {
                hook.setEditable(true);
                window.scrollTo({ top: 500, behavior: "smooth" });
              }}
              hasPermission={hasPermission}
              isSignedLocked={hook.isSignedLocked}
            />
          )}
        </div>
      </div>
    </>
  );
};
